/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export enum RotateElementReturnCodes {
    Success = 0,
    IncorrectStructure = 1,
    IncorrectRotationValue = 2,
    AssemblySelected = 3,
    InvalidSelection = 4
  }